// src/CharacterSetupScreen.jsx
import React, { useState } from "react";
import axios from "axios";
import "./CharacterSetupScreen.css";

// 1) 이미지 경로 배열
const characterImages = [
  "/assets/man-a-large.png",
  "/assets/man-b-large.png",
  "/assets/man-c-large.png",
  "/assets/woman-a-large.png",
  "/assets/woman-b-large.png",
  "/assets/woman-c-large.png",
];

// 2) 파일명(ex: "man-a-large") 배열 생성
const characterTypes = characterImages.map((path) =>
  path.split("/").pop().replace(".png", "")
);

export default function CharacterSetupScreen({
  user,
  signupToken,
  onComplete,
}) {
  const [idx, setIdx] = useState(0);
  const [nickname, setNickname] = useState("");

  const prev = () =>
    setIdx((i) => (i - 1 + characterImages.length) % characterImages.length);
  const next = () =>
    setIdx((i) => (i + 1) % characterImages.length);
  const clear = () => setNickname("");

  const confirm = async () => {
    try {
        const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/signup`,
        {
          email: user.email,
          name: user.name,
          picture: user.picture,
          nickname,
          characterType: characterTypes[idx],  // 파일명 그대로 전송
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${signupToken}`,
          },
        }
      );
         onComplete({
             user: data.user,
             accessToken: data.token,
             refreshToken: data.refreshToken
           });
    } catch {
      alert("회원가입에 실패했습니다.");
    }
  };

  return (
    <div className="char-container">
      <div className="char-header">캐릭터 설정</div>

      <div className="char-preview">
        <img src={characterImages[idx]} alt="캐릭터" />
      </div>

      <div className="char-selector">
        <button className="arrow-btn" onClick={prev}>
          &lt;
        </button>

        <div className="input-wrap">
          <input
            type="text"
            className="nickname-input"
            placeholder="닉네임을 입력하세요"
            maxLength={10}
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
          />
          {nickname && (
            <button className="clear-btn" onClick={clear}>
              ×
            </button>
          )}
          <div className="counter">{nickname.length}/10</div>
        </div>

        <button className="arrow-btn" onClick={next}>
          &gt;
        </button>
      </div>

      <button
        className="confirm-btn"
        disabled={!nickname}
        onClick={confirm}
      >
        확인
      </button>
    </div>
  );
}
